module.exports = __webpack_public_path__ + "static/img/1.1ff6400.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/zh/1.png
// module id = pEeu
// module chunks = 0